<template>
    <div :class="{'loading': loading}">
        <div v-if="status" :class="['alert', 'alert-' + status]" role="alert" v-html="message"></div>
        <div v-if="model.state == 'code'" class="col-md-6 m-auto">
            <div class="form-floating">
                <input type="password" v-model="model.code" class="form-control" @keyup.enter="submitCode" ref="passwordInput" placeholder="Password">
                <label for="code" class="text-start">Password</label>
            </div>
            <div v-if="!model.forgotPasswordSent" class="mt-2">
                <button class="btn btn-link" @click="forgot">I forgot my password</button>
            </div>
            <div class="m-4 text-center">
                <div class="mb-4 form-check">
                    <label for="untilSignout">
                        <input id="untilSignout" class="form-check-input" type="checkbox" v-model="model.untilSignout" />
                        Stay signed in
                    </label>
                </div>
                <button class="btn btn-lg btn-primary w-100" @click="submitCode" role="button" :disabled="loading">
                    <i class="fa fa-circle-notch fa-spin m-1" loading></i>Submit<i class="fa fa-invisible m-1"></i>
                </button>
            </div>
        </div>
        <div v-if="model.state == 'start'" class="col-md-6 m-auto">
            <div class="form-floating">
                <input type="email" v-model="model.email" class="form-control" @keyup.enter="submit" autofocus placeholder="Email address">
                <label>Email address</label>
            </div>
            <div class="m-4">
                <h4 class="text-center">OR</h4>
            </div>
            <div class="form-floating">
                <input type="tel" v-model="model.phone" class="form-control" @keyup.enter="submit" placeholder="Mobile number">
                <label>Mobile number</label>
            </div>
            <div class="mt-4 text-center">
                <button class="btn btn-lg btn-primary w-100" @click="submit" role="button" :disabled="loading">
                <i class="fa fa-circle-notch fa-spin m-1" loading></i>Submit<i class="fa fa-invisible m-1"></i>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: ['recaptchakey', 'returnurl'],
        data: function () {
            return {
                message: '',
                status: '',
                loading: false,
                model: {
                    id: null,
                    state: 'start',
                    code: '',
                    codeKey: '',
                    email: '',
                    phone: '',
                    recaptchaToken: '',
                    forgotPasswordSent: false,
                    untilSignout: true,
                },
            };
        },
        //components: {
        //},
        //computed: {
        //},
        methods: {
            forgot() {
                this.post('/signin/forgot');
            },
            post(url) {
                const vm = this;
                vm.loading = true;
                vm.model.returnUrl = vm.model.returnUrl || vm.returnurl;
                axios.post(url ?? '/signin', vm.model).then(result => {
                    var data = result.data;
                    if (data.status == 'redirect') {
                        window.location.replace(data.model);
                    } else {
                        vm.message = data.message;
                        vm.model = data.model;
                        vm.status = data.status;
                    }
                }).catch(error => {
                    vm.showError(error);
                }).finally(() => {
                    vm.loading = null;
                });
            },
            showError(error) {
                this.message = `Oops! Something didn't go as planned. The actual error was:<br><b>"${error}"<b>`;
                this.status = 'danger';
            },
            submit() {
                const vm = this;
                grecaptcha.enterprise.ready(async () => {
                    const token = await grecaptcha.enterprise.execute(vm.recaptchakey, { action: 'signin' });
                    vm.model.recaptchaToken = token;
                    vm.post();
                });
            },
            submitCode() {
                this.post();
            }
        },
        watch: {
            'model.state': function (state) {
                if (state === 'code') this.$nextTick(e => {
                    this.$refs.passwordInput.focus();
                });
            }
        }
    };
</script>